import React, { Suspense, useEffect } from 'react';
import {
  Link,
  Redirect,
  Route,
  Switch,
  useHistory,
  useLocation,
  useRouteMatch,
} from 'react-router-dom';
import { Header, Menu } from 'semantic-ui-react';
import AppBar from '../Common/AppBar/AppBar';
import '../Common/Layout.css';
import { isSuperAdmin } from '../Common/memberUtils';
import { useStitchAuth } from '../StitchAuth';

export default function Admin() {
  let history = useHistory();
  const { userCustomData } = useStitchAuth();
  const pvStart = new Date().getTime();
  let { path, url } = useRouteMatch();
  const viewList = [
    { pathname: 'manage-users', title: 'Manage Users' },
    { pathname: 'add-user', title: 'Add User' },
    { pathname: 'view-workspaces', title: 'View Workspaces' },
    { pathname: 'workspace-activity', title: 'Workspace Activity' },
    { pathname: 'manage-workspace', title: 'Manage Workspace' },
    { pathname: 'setup-contract', title: 'Setup Contract' },
    { pathname: 'order-devices', title: 'Bulk Device Orders' },
    { pathname: 'order-history', title: 'Order History' },
    { pathname: 'platform-metrics', title: 'Platform Metrics' },
    {
      pathname: 'manage-devices',
      title: 'Manage Devices',
    },
  ];
  const location = useLocation();

  const ManageUsers = React.lazy(() =>
    import('./ManageUsers/ManageUsers'),
  );
  const ManageWorkspaces = React.lazy(() =>
    import('./ManageWorkspaces/ManageWorkspaces'),
  );
  const AddUser = React.lazy(() => import('./AddUser/AddUser'));
  const AddWorkspace = React.lazy(() => import('./AddWorkspace/AddWorkspace'));
  const SetupContract = React.lazy(() => import('./SetupContract/SetupContract'));
  const OrderDevices = React.lazy(() => import('./OrderDevices/OrderDevices'));
  const OrderHistory = React.lazy(() => import('./OrderHistory/OrderHistory'));
  const PlatformMetrics = React.lazy(() =>
    import('./PlatformMetrics/PlatformMetrics'),
  );
  const WorkspaceActivity = React.lazy(() =>
    import('./WorkspaceActivity/WorkspaceActivity'),
  );
  const DeviceAssignmentTracking = React.lazy(() =>
    import('./DeviceAssignmentTracking/DeviceAssignmentTracking'),
  );

  useEffect(() => {
    if (userCustomData && !isSuperAdmin(userCustomData)) {
      history.replace('/home');
    }
  }, [userCustomData, history]);

  return (
    <div className="app-layout">
      <AppBar />
      <div className="channels box">
        <Header as="h4" style={{ paddingLeft: '1em', color: '#fff' }}>
          Admin Panel
        </Header>
        <Menu
          vertical
          secondary
          inverted
          style={{ background: 'transparent' }}
        >
          {viewList.map((view) => (
            <Menu.Item
              key={view.pathname}
              active={location.pathname === `/admin/${view.pathname}`}
            >
              <Link to={`${url}/${view.pathname}`}>
                {`#  ${view.pathname}`}
              </Link>
            </Menu.Item>
          ))}
        </Menu>
      </div>
      <div className="header-panel box">
        <Header as="h3">
          {
            (
              viewList.find(
                (view) =>
                  location.pathname === `/admin/${view.pathname}`,
              ) || {}
            ).title
          }
          <Header.Subheader>
            <small>
              last updated at {new Date(pvStart).toLocaleString()}
            </small>
          </Header.Subheader>
        </Header>
      </div>
      <Suspense fallback={<div>Loading...</div>}>
        <Switch>
          <Route exact path={path}>
            <Redirect to={{ pathname: `${path}/manage-users` }} />
          </Route>
          <Route path={`${path}/manage-users`}>
            <ManageUsers />
          </Route>
          <Route path={`${path}/view-workspaces`}>
            <ManageWorkspaces />
          </Route>
          <Route path={`${path}/workspace-activity`}>
            <WorkspaceActivity />
          </Route>
          <Route path={`${path}/add-user`}>
            <AddUser />
          </Route>
          <Route path={`${path}/manage-workspace`}>
            <AddWorkspace />
          </Route>
          <Route path={`${path}/setup-contract`}>
            <SetupContract />
          </Route>
          <Route path={`${path}/order-devices`}>
            <OrderDevices />
          </Route>
          <Route path={`${path}/order-history`}>
            <OrderHistory />
          </Route>
          <Route path={`${path}/platform-metrics`}>
            <PlatformMetrics />
          </Route>
          <Route path={`${path}/manage-devices`}>
            <DeviceAssignmentTracking />
          </Route>
          <Route path={`${path}/device-assignment-tracking`}>
            <Redirect to={`${path}/manage-devices`} />
          </Route>
        </Switch>
      </Suspense>
    </div>
  );
}
